export const aciCarryOn = {
    iconName: 'carry-on',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M8.041 12.648l.002-.002-.002.002zm.038-.025a.599.599 0 01.273-.057h8.386c.125 0 .22.03.272.057v6.72a.599.599 0 01-.272.057H8.352a.599.599 0 01-.273-.058v-6.719zm-.038 6.694l.002.002-.002-.002zm9.007 0l-.002.002a.013.013 0 01.002-.002zm0-6.669l-.002-.002a.012.012 0 01.002.002zm-9.592-.971c.256-.162.574-.243.896-.243h8.386c.322 0 .64.081.895.243.249.157.51.445.51.854v6.904c0 .409-.261.696-.51.854a1.687 1.687 0 01-.895.243H8.352c-.322 0-.64-.081-.896-.243-.248-.158-.509-.445-.509-.854v-6.904c0-.409.26-.697.51-.854z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M11.287 3.132a.692.692 0 00-.692.692v7.758a.566.566 0 01-1.132 0V3.824A1.824 1.824 0 0111.287 2h2.515a1.824 1.824 0 011.824 1.824v7.758a.566.566 0 11-1.132 0V3.824a.692.692 0 00-.691-.692h-2.516zM10.45 13.95c.313 0 .567.253.567.565v2.516a.566.566 0 11-1.132 0v-2.516c0-.312.253-.566.566-.566zM14.224 13.95c.313 0 .566.253.566.565v2.516a.566.566 0 01-1.132 0v-2.516c0-.312.254-.566.566-.566zM10.029 19.61c.313 0 .566.253.566.565v1.258a.566.566 0 01-1.132 0v-1.258c0-.312.253-.566.566-.566zM15.06 19.61c.313 0 .566.253.566.565v1.258a.566.566 0 11-1.132 0v-1.258c0-.312.254-.566.566-.566z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
